var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#ffffff",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.18,
    y: 16.7,
    width: 50.86,
    height: 29.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.22,16.55a10,10,0,0,1-10,10.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.51,46.57a10.05,10.05,0,0,0-10-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.16,16.55A10.05,10.05,0,0,0,58.21,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,46.57a10.05,10.05,0,0,1,10-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.47,22.3H31c2.49,0,5.23.81,5.23,4.6,0,4.11-3.48,5.68-7.18,5.26a.21.21,0,0,0-.17.36L36.74,41",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.24,
    y1: 22.3,
    x2: 30.45,
    y2: 22.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.59,
    y1: 27.03,
    x2: 39.3,
    y2: 27.03,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.139acd29b1525bdda90245b7ff6dfe16.svg";
export { ForwardRef as ReactComponent };